import { CREATE_FORMS_LOADING_STATES } from "../../../web/businesslogic/formssection/createform/constants";
import { FIELD_TYPES, HANDLE_DEPENDENTFIELDS_CB_FOR_FIELD_TYPES, IRS_DROPDOWN_SELECT_CB_FIELDS, VALIDATION_RULE } from "../../formdatavalidator/constants";
import FormDataValidator from "../../formdatavalidator/FormDataValidator";
import { FORM_FIELD_NAMES, FORM_NAMES } from "../constants";
import Forms from "../formsutility/Forms";

export default class FormEventHandlers {
    static inputValueChange(e, currentFormField, tempFormFieldsList, updateCb, toCreateFormData, onDependentFields, onDependentFieldChangeGetValuesCb, isIRSViewOn = false) {
        const updatedBoxesList = tempFormFieldsList.map((item) => {
            if (item?.Name === currentFormField.Name) {
                if (item.Type === FIELD_TYPES.BOOLEAN) {
                    let tempCurrUpdatedField = {
                        ...item,
                        oldInputValue: item.inputValue || "", 
                        inputValue: e.target.checked,
                    }
                    const validationResult = FormDataValidator.validate(tempCurrUpdatedField, tempFormFieldsList);
                    return {
                        ...tempCurrUpdatedField,
                        validationResult: validationResult,
                    }
                } else if (item.Type === FIELD_TYPES.RADIO) {
                    let tempCurrUpdatedField = {
                        ...item,
                        oldInputValue: item.inputValue || "", 
                        inputValue: e.target.value,
                    }
                    const validationResult = FormDataValidator.validate(tempCurrUpdatedField, tempFormFieldsList);
                    return {
                        ...tempCurrUpdatedField,
                        validationResult: validationResult,
                    }
                } else if (item.Type === FIELD_TYPES.DATE) {
                    const tempVar = {
                        ...item,
                        oldInputValue: item.inputValue || "",
                        inputValue: e,
                    };
                    return tempVar;
                } else if (item.Type === FIELD_TYPES.FREEHANDDRAW) {
                    const tempVar = {
                        ...item,
                        oldInputValue: item.inputValue || "",
                        inputValue: e.substring(e.indexOf(',') + 1),
                    };
                    return tempVar;
                } else if ((item.Type === FIELD_TYPES.BUTTON) || (item.Type === FIELD_TYPES.LABEL)) {
                    return item;
                } else if (item.Type === FIELD_TYPES.FILE_UPLOAD) {
                    let tempCurrUpdatedField = {
                        ...item,
                        inputValue: e,
                    }
                    const validationResult = FormDataValidator.validate(tempCurrUpdatedField, tempFormFieldsList);
                    return {
                        ...tempCurrUpdatedField,
                        validationResult: validationResult,
                    }
                } else {
                    const newItem =  {
                        ...item,
                        oldInputValue: item?.inputValue || "", 
                        inputValue: e.target.value,
                    };
                    return newItem
                }
            } else {
                return item;
            }
        });
        let finalUpdatedFieldsList = updatedBoxesList;
        if(currentFormField.Validations.hasOwnProperty(VALIDATION_RULE.ATLEASTONEFIELDREQUIRED)){
            const {newTempFormFieldsList, isErrorFree} = Forms.checkErrorForEachRelevantField(currentFormField?.Category, updatedBoxesList, isIRSViewOn, (field, allFieldsList) => FormDataValidator.validate(field, allFieldsList));
            finalUpdatedFieldsList = newTempFormFieldsList;
        }
        updateCb(finalUpdatedFieldsList);

        if (HANDLE_DEPENDENTFIELDS_CB_FOR_FIELD_TYPES.includes(currentFormField.Type) &&
            onDependentFields.hasOwnProperty(currentFormField.Name)
        ) {
            onDependentFieldChangeGetValuesCb({
                formId: toCreateFormData?.selectedForm?.FormId ?? null,
                year: toCreateFormData?.selectedYear ?? null,
                fieldId: currentFormField.Name,
                allFields: finalUpdatedFieldsList,
            });
        }
    }

    static handleOnBlur(e, currentFormField, tempFormFieldsList, inputValidationResult, toCreateFormData, onDependentFields, updateTempFormFieldsListCb, onDependentFieldChangeGetValuesCb) {

        const updatedBoxesList = tempFormFieldsList.map((item) => {
            if (item?.Name === currentFormField.Name) {
                return {
                    ...item,
                    validationResult: inputValidationResult,
                };
            } else {
                return item;
            }
        });
        updateTempFormFieldsListCb(updatedBoxesList);

        if (
            !inputValidationResult?.isError &&
            onDependentFields.hasOwnProperty(currentFormField.Name) &&
            currentFormField.oldInputValue !== undefined
        ) {
            onDependentFieldChangeGetValuesCb({
                formId: toCreateFormData?.selectedForm?.FormId ?? null,
                year: toCreateFormData?.selectedYear ?? null,
                fieldId: currentFormField.Name,
                allFields: updatedBoxesList,
                targetElement: e.relatedTarget?.name
            });
        }

    };

    static handleDropDownValueChange(name, selectedOption, tempFormFieldsList, toCreateFormData, onDependentFields, updateTempFormFieldsList, onDependentFieldChangeGetValuesCb, IRSViewPayerRecipientOnSelectCb=()=>{}, shouldCallOnDependentFieldChangeGetValuesCb = true, dispatchNotificationCb = () => {}, isIRSViewOn = true, getRecipientListCb = () => {}, setToCreateFormDataCb = () => {}) {
        let currentField = null;
        if(selectedOption && selectedOption.hasOwnProperty('RecipentDetailId') && selectedOption.hasOwnProperty('TinStatus') && selectedOption.TinStatus === "Blocked"){
            dispatchNotificationCb(
                "Recipient TIN Verficaiton failed", 
                "Please select a differnt recipient or initiate a TIN verification for this recipient before proceeding forward.", 
                "DANGER")
            return
        }

        if(name == FORM_FIELD_NAMES.ISSUER_ID && toCreateFormData?.selectedForm?.FormId == FORM_NAMES.FORM1095B){
            if(toCreateFormData?.selectedPayer == null){
                setToCreateFormDataCb({selectedRecipient: null});
                getRecipientListCb(selectedOption?.value);
            }
        }
        
            const updatedFieldsList = tempFormFieldsList.map((item) => {
            if(item?.Name === name){
                currentField = item;
                if(item?.Type === (FIELD_TYPES.ENUM || FIELD_TYPES.ENUM_MODAL)){
                    const currentUpdateItem = {
                        ...item,
                        inputValue: selectedOption.value,
                    };
                    const validationResult = FormDataValidator.validate(currentUpdateItem, tempFormFieldsList);
                    return {
                        ...currentUpdateItem,
                        validationResult: {...validationResult},
                    }
                }else if(item?.Type === FIELD_TYPES.MULTISELECTENUM){
                    const currentUpdateItem = {
                        ...item,
                        inputValue: selectedOption
                            .map(function(item) {
                                return item.value;
                            })
                            .filter(function(value) {
                                return value !== '';
                            })
                            .join(','),
                    };
                    const validationResult = FormDataValidator.validate(currentUpdateItem, tempFormFieldsList);
                    return {
                        ...currentUpdateItem,
                        validationResult: {...validationResult},
                    }
                }else{
                    return item;
                }
            }else{
                return item;
            }
        });
        let finalUpdatedFieldsList = updatedFieldsList;
        if(currentField && currentField.Validations.hasOwnProperty(VALIDATION_RULE.ATLEASTONEFIELDREQUIRED)){
            const {newTempFormFieldsList, isErrorFree} = Forms.checkErrorForEachRelevantField(currentField?.Category, finalUpdatedFieldsList, isIRSViewOn, (field, allFieldsList) => FormDataValidator.validate(field, allFieldsList));
            finalUpdatedFieldsList = newTempFormFieldsList;
        }
        updateTempFormFieldsList(finalUpdatedFieldsList);

        IRSViewPayerRecipientOnSelectCb(selectedOption, finalUpdatedFieldsList);

        if (shouldCallOnDependentFieldChangeGetValuesCb && !IRS_DROPDOWN_SELECT_CB_FIELDS.hasOwnProperty(name) && onDependentFields.hasOwnProperty(name)){
            onDependentFieldChangeGetValuesCb({
                formId: toCreateFormData?.selectedForm?.FormId ?? null,
                year: toCreateFormData?.selectedYear ?? null,
                fieldId: name,
                allFields: finalUpdatedFieldsList,
            })
        }
    }

    static handleUserInteractionPopupBtnClick (userResponse, userInteractionPopupWResponseObj, updateTempFormFieldsListCb, resetUserInteractionPopupWResponseObjCb) {
        const updatedBoxesList = userResponse
            ? userInteractionPopupWResponseObj.positiveResponse
            : userInteractionPopupWResponseObj.negativeResponse;
        updateTempFormFieldsListCb(updatedBoxesList);
        resetUserInteractionPopupWResponseObjCb();
    };

    static handleInitialRenderPopup (userResponse, userInteractionPopupWResponseObj, resetUserInteractionPopupWResponseObjCb){
        //This function can be extended to handle various future scenarios.
        resetUserInteractionPopupWResponseObjCb();
    }

    static handleNextBtnClick(currentStep, tempFormFieldsList, isIRSViewOn = false, updateTempFormFieldsListCb, updateErrorNotificationCb, isBoiReportingModule = false ) {
        const {newTempFormFieldsList, isErrorFree} = Forms.checkErrorForEachRelevantField(currentStep, tempFormFieldsList, isIRSViewOn, (field, allFieldsList) => FormDataValidator.validate(field, allFieldsList), isBoiReportingModule);
        updateTempFormFieldsListCb(newTempFormFieldsList);
        if(isErrorFree){
            return true;
        }
        updateErrorNotificationCb();
        return false;
    }

    static updateTempFormFieldsListOnPayerSelect(tempFormFieldsList, toCreateFormData, setTempFormFieldsListCb, shouldUpdateTempFormFieldsList = true){
        const newTempFormFieldsList = tempFormFieldsList.map(item => {
            let currentItem;
            const checkPayerKeyMapping = Forms.getPayerDetailsKey(item.Name);
            if(checkPayerKeyMapping){
                if(item.Name === "LastFiling"){
                    currentItem = {
                        ...item,
                        inputValue: ((toCreateFormData?.selectedPayer && toCreateFormData.selectedPayer.hasOwnProperty(checkPayerKeyMapping) && toCreateFormData?.selectedPayer[checkPayerKeyMapping] === "1") ? true : false),
                    };
                }else{
                    currentItem = {
                        ...item,
                        inputValue: ((toCreateFormData?.selectedPayer && toCreateFormData.selectedPayer.hasOwnProperty(checkPayerKeyMapping)) ? toCreateFormData.selectedPayer[checkPayerKeyMapping] : null),
                    };
                    const inputValidationResult = FormDataValidator.validate(currentItem, tempFormFieldsList);
                    currentItem = {
                        ...currentItem,
                        validationResult: inputValidationResult,
                    }
                }
            } else {
                currentItem = item;
            }
            // const inputValidationResult = FormDataValidator.validate(currentItem, tempFormFieldsList); //by this on selection of recipient all fields were getting validated and shown error messages below the field. Removed it and observing if something else doesnt work. Hence commented
            return {
                ...currentItem,
                // validationResult: inputValidationResult,
            }

        });
        if(shouldUpdateTempFormFieldsList){
            setTempFormFieldsListCb(newTempFormFieldsList);
        }
        return newTempFormFieldsList;
    }

    static handleRecipientSelect(tempFormFieldsList, toCreateFormData, setTempFormFieldsListCb, onDependentFieldChangeGetValuesCb, shouldUpdateTempFormFieldsList = true, shouldCallOnDependentFieldChangeGetValuesCb = true){

        const newTempFormFieldsList = tempFormFieldsList.map(item => {
            let currentItem;
            const checkRecipientKeyMapping = Forms.getRecipientKeyFromPayeeKey(item.Name);
            if(checkRecipientKeyMapping){
                currentItem = {
                    ...item,
                    inputValue: (toCreateFormData?.selectedRecipient && toCreateFormData?.selectedRecipient.hasOwnProperty(checkRecipientKeyMapping)) ?  toCreateFormData.selectedRecipient[checkRecipientKeyMapping] : null,
                };
                const inputValidationResult = FormDataValidator.validate(currentItem, tempFormFieldsList); //
                currentItem = {
                    ...currentItem,
                    validationResult: inputValidationResult,
                }
            }else{
                currentItem = item;
            }
            // const inputValidationResult = FormDataValidator.validate(currentItem, tempFormFieldsList); //by this on selection of recipient all fields were getting validated and shown error messages below the field. Removed it and observing if something else doesnt work.
            return {
                ...currentItem,
                // validationResult: inputValidationResult,
            }

        });
        if(shouldUpdateTempFormFieldsList){
            setTempFormFieldsListCb(newTempFormFieldsList);
        }

        if(shouldCallOnDependentFieldChangeGetValuesCb && toCreateFormData?.selectedRecipient !== null){
            onDependentFieldChangeGetValuesCb({
                formId: toCreateFormData?.selectedForm.FormId,
                year: toCreateFormData?.selectedYear,
                fieldId: "PayeeState",
                allFields: newTempFormFieldsList,
            });
        }

        return newTempFormFieldsList;
    }

    static updateOnPayerSelectAndFormSelect(toCreateFormData, getRecipientsCb, formsPreLoadedData = {}, setToCreateFormDataCb = () => {}, shouldSelectedPayerBeNULL = false, shouldSelectedRecipientBeNULL = false, editRecipientModeOn = false, getRecipientCb = () => {} ){
        if(toCreateFormData?.selectedPayer?.PayerDetailId && toCreateFormData?.selectedForm?.FormId && formsPreLoadedData?.ShowRecipientStep){
            
            if(editRecipientModeOn){
                getRecipientCb();
            }

            getRecipientsCb({
                PayerId: toCreateFormData.selectedPayer.PayerDetailId,
                FormName: toCreateFormData.selectedForm.FormId,
                Search: "",
                PerPage : null,
                LoadableLoadingState: {
                    loading: CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_LOADING,
                    ready: CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_READY,
                }
            });
            if (shouldSelectedPayerBeNULL) {
                setToCreateFormDataCb({selectedPayer: null});
            }
            if (shouldSelectedRecipientBeNULL) {
                setToCreateFormDataCb({selectedRecipient: null});
            }
        }
    }

    static updateDependentFieldsArr(tempFormFieldsList, setOnDependentFieldsCb){
        let reverseDependencyMap = {};
        tempFormFieldsList.forEach((obj) => {
            if (obj?.DependentFields) {
                obj?.DependentFields.forEach((fieldName) => {
                    reverseDependencyMap[fieldName] = true;
                });
            }
        });
        setOnDependentFieldsCb(reverseDependencyMap);
    }

    static updateOnFormSelectAndYearSelect(toCreateFormData, formsPreLoadedData, getFormFieldsFlag = true, getFormDataCb, updateFormsPreLoadedDataCb = () => {}){
        if(toCreateFormData?.selectedForm != null){
            getFormDataCb({formName: toCreateFormData.selectedForm.FormId, formYear: toCreateFormData.selectedYear, toCreateFormData: toCreateFormData, formsPreLoadedData: formsPreLoadedData, getFormFieldsFlag: getFormFieldsFlag});
            const availableYears = toCreateFormData?.selectedForm?.Year.map((item) => {
                return {
                    label: item.toString(),
                    value: item,
                }
            });
            updateFormsPreLoadedDataCb({ selectedFormYears: availableYears });
        }
    }

    static _handleIRSPayerOrRecipientSelect (payerOrRecipient, updatedTempFieldsList, getPayerCb) {
        if(payerOrRecipient.hasOwnProperty("PayerDetailId")){
            getPayerCb(payerOrRecipient?.PayerDetailId, "PAYER", updatedTempFieldsList);
        }else if(payerOrRecipient.hasOwnProperty("RecipentDetailId")){         
            getPayerCb(payerOrRecipient?.RecipentDetailId, "RECIPIENT", updatedTempFieldsList)            
        }
    }

    static _handleFormYearSelect (selectedObject, createFormDataCb) {
        createFormDataCb({selectedYear: selectedObject.value});
    }

    static handleIRSViewDropDownSelect (field, selectedObject, updatedTempFieldsList, getPayerCb, createFormDataCb) {
        if(field.Type === FIELD_TYPES.ENUM || FIELD_TYPES.ENUM_MODAL){
            switch(field?.Name){
                case IRS_DROPDOWN_SELECT_CB_FIELDS.PAYERID:
                case IRS_DROPDOWN_SELECT_CB_FIELDS.PAYEEID:
                    return this._handleIRSPayerOrRecipientSelect(selectedObject, updatedTempFieldsList, getPayerCb);
                case IRS_DROPDOWN_SELECT_CB_FIELDS.YEARID: 
                    return this._handleFormYearSelect(selectedObject, createFormDataCb);
                default:
                    return () => {}
            }
        }else{
            return () => {}
        }
         
    }

    static handleAddEditIntermediaryAction (setIntermediaryIdForEditCb, setIsOpenIntermediaryPopupCb, intermediaryId = null){
        setIntermediaryIdForEditCb(intermediaryId);
		setIsOpenIntermediaryPopupCb(true);
    }
}